/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

// @mui material components
import Card from '@mui/material/Card';
import Icon from '@mui/material/Icon';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';
import MDSnackbar from 'components/MDSnackbar';
import MDTypography from 'components/MDTypography';

// Material Dashboard 2 PRO React examples
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import Navbar from 'examples/Navbars/NavBar';
import Footer from 'examples/Footer';
import { useTranslation } from 'react-i18next';
import { APP_STATE } from 'services/Define';
import { FetchData } from 'services/Request';
import { useSelector } from 'react-redux';
import * as Func from 'services/Function';
import AdvertiseUpload from './AdvertiseUpload';

const initAttr = {
  id: '',
  name: '',
  enable: 'Y',
  created_at: '',
  updated_at: '',
};

function AdvertiseImage() {
  const mod = 'advertise_image';
  const app = useSelector((state) => state[APP_STATE]);
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const [record, setRecord] = useState([]);
  const [attr, setAttr] = useState(initAttr);
  const [notify, setNotify] = useState(null);
  const [confirm, setConfirm] = useState(false);
  const [loading, setLoading] = useState(true);
  const [modalDel, setModalDel] = useState(false);

  const showNotify = (msg, color) => {
    setNotify(
      <MDSnackbar
        color={color}
        icon='notifications'
        title={t(`app.name`)}
        content={msg}
        dateTime={Func.dateTimeDisplay()}
        open={Boolean(true)}
        close={() => setNotify(!notify)}
      />
    );

    setTimeout(function () {
      setNotify(null);
    }, 3000);
  };

  const view = () => {
    setLoading(true);
    setRecord([]);

    FetchData('POST', `/${mod}`, app.token, {
      lang: app.lang,
    }).then((result) => {
      if (result.status === 'ok') {
        setRecord(result.data);
      }
      setLoading(false);
    });
  };

  const add = (filedata) => {
    setLoading(true);

    FetchData('PUT', `/${mod}`, app.token, {
      id: id,
      filedata: filedata,
    }).then((result) => {
      setLoading(false);

      if (result.status === 'ok') {
        view();
        showNotify(t(`alert.addcomplete`), 'success');
      } else {
        showNotify(t(`alert.saveerror`), 'error');
      }
    });
  };

  const del = () => {
    setLoading(true);
    setModalDel(false);

    FetchData('DELETE', `/${mod}/${attr.id}`, app.token, {}).then((result) => {
      setLoading(false);

      if (result.status === 'ok') {
        view();
        showNotify(t(`alert.deletecomplete`), 'success');
      } else {
        showNotify(t(`alert.deleteerror`), 'error');
      }
    });
  };

  const renderLoading = () => {
    return (
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color='inherit' />
      </Backdrop>
    );
  };

  const btnDel = (item) => {
    return (
      <MDBox className='text-right'>
        <IconButton
          color='error'
          onClick={() => {
            setConfirm(false);
            setAttr(item);
            setModalDel(true);
          }}
        >
          <Icon>delete</Icon>
        </IconButton>
      </MDBox>
    );
  };

  const renderButton = () => {
    return (
      <Card sx={{ p: 2 }}>
        <MDBox display='flex' justifyContent='end' gap={1}>
          <AdvertiseUpload uploadData={add} />
        </MDBox>
      </Card>
    );
  };

  const renderList = () => {
    return (
      <MDBox mb={7}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            {renderButton()}
          </Grid>
          <Grid item xs={12}>
            <Card>
              <MDBox p={2}>
                <Grid container spacing={2}>
                  {record.map((item) => (
                    <Grid item xs={12} sm={12} md={6} lg={4} key={item.id}>
                      <MDBox className='card-img'>
                        {btnDel(item)}
                        <CardHeader
                          title={`Photo ID : #${item.id}`}
                          subheader={Func.dateTimeDisplay(item.created_at)}
                        />
                        <CardMedia sx={{ height: 109, mt: 0 }} image={item.image} title={item.id} />
                        <CardContent>
                          <MDTypography variant='body2'>สร้างโดย : {item.user_name}</MDTypography>
                        </CardContent>
                      </MDBox>
                    </Grid>
                  ))}
                </Grid>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderDelete = () => {
    return (
      <Dialog
        open={modalDel}
        onClose={() => setModalDel(false)}
        maxWidth='xs'
        keepMounted
        aria-describedby='dialog-delete'
        fullWidth
      >
        <DialogTitle>
          {t(`element.delete`)} #{attr.id}
          <IconButton
            aria-label='close'
            onClick={() => setModalDel(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <DialogContentText p={3}>{t(`alert.confirm_delete_title`)}</DialogContentText>
        </DialogContent>
        <DialogActions>
          {confirm ? (
            <Grid container>
              <Grid item xs={6}>
                <MDButton variant='text' color='error' onClick={() => setModalDel(false)}>
                  <Icon>cancel</Icon>&nbsp;{t(`element.cancel`)}
                </MDButton>
              </Grid>
              <Grid item xs={6} display='flex' justifyContent='flex-end'>
                <MDButton variant='gradient' color='error' onClick={del}>
                  <Icon>delete</Icon>&nbsp;{t(`element.deleteconfirm`)}
                </MDButton>
              </Grid>
            </Grid>
          ) : (
            <MDButton variant='text' color='error' onClick={() => setConfirm(true)}>
              <Icon>delete</Icon>&nbsp;{t(`element.delete`)}
            </MDButton>
          )}
        </DialogActions>
      </Dialog>
    );
  };

  useEffect(() => {
    i18n.changeLanguage(app.lang);

    view();
  }, [id]);

  return (
    <DashboardLayout>
      <Navbar route={[t(`menu.sale`), t(`menu.advertise_image`)]} />
      {renderList()}
      {renderDelete()}
      <Footer />
      {renderLoading()}
      {notify}
    </DashboardLayout>
  );
}

export default AdvertiseImage;
